import { API } from 'consts';
import { get, post } from 'api/api';
import { PaymentPlan } from './types/owner';

export const refreshAccountLink = (payoutMethodId) => {
  window.location.href = `${API.root}services/stripe/refresh/${payoutMethodId}/`;
};

type StripeCheckoutSessionResponse = {
  session: string;
  url: string;
  message?: string;
};

type StripeLoginLink = {
  object: 'login_link';
  created: number;
  url: string;
};

export const getDashboardLink = (payoutMethodId) => {
  return get<StripeLoginLink>(`/services/stripe/login/${payoutMethodId}/`);
};

export type StripePaymentPlan = {
  displayName: string;
  planType: PaymentPlan;
  currency: string;
  price: number;
  lookupKey?: string;
  priceId?: string;
  product?: string;
  interval?: 'month' | 'year';
  image?: string;
};

export const getPaymentPlans = () => {
  return get<StripePaymentPlan[]>('/services/stripe/plans/');
};

export const createPaymentPlanCheckout = async (
  paymentPlanId: string,
  toltCustomerId: string | null,
) => {
  const response = await post<StripeCheckoutSessionResponse>(
    `/services/stripe/subscribe/${paymentPlanId}/`,
    {
      tolt_customer_id: toltCustomerId,
    },
  );
  if (!response.ok) {
    throw new Error(response.data.message);
  }
  window.location.href = response.data.url;
};

export const getSubscriptionManagementLink = () => {
  return post<{ url: string }>(`/services/stripe/subscription/manage/`);
};
